import React from 'react'
import FormX from 'sb-formx'
import { required } from 'helpers/validation'
import { useMemo, useCallback } from 'sb-hooks'
import { constants } from 'common/helpers'

import { Field } from 'components/_new/forms'
import { Button, buttonMessages } from 'components/_new/controls'

import messages from './messages'
import s from './ReplyForm.scss'


type ReplyFormProps = {
  className?: string
  onSubmit: (values: { message: string }) => void,
  onCancel: () => void,
}


const ReplyForm: React.FunctionComponent<ReplyFormProps> = ({ className, onSubmit, onCancel }) => {
  const form = useMemo(() => (
    new FormX({
      name: 'ReplyForm',
      fields: {
        message: [ required ],
      },
    })
  ), [])

  const handleSubmit = useCallback(() => {
    form.submit()
      .then((values) => {
        onSubmit(values)
      })
  }, [ onSubmit ])

  return (
    <div className={className}>
      <Field
        field={form.fields.message}
        label={messages.placeholder}
        dataTestId={constants.testIds.replyForm.message}
        standardView
        rows={3}
      />
      <div className={s.actions}>
        <div className={s.buttons}>
          <Button
            className={s.cancelButton}
            title={buttonMessages.cancel}
            color="transparent"
            size="sm"
            dataTestId={constants.testIds.replyForm.cancelButton}
            onClick={onCancel}
          />
          <Button
            title={buttonMessages.reply}
            color="brand"
            size="sm"
            dataTestId={constants.testIds.replyForm.submitButton}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}


export default ReplyForm
